import React from 'react';
export function StickyHeader() {
  return <div className="sticky top-0 z-40 flex min-h-[36px] w-full items-center justify-center bg-cobalt px-4 py-2 text-center" data-id="element-185" data-mp="2zat6uoerv308">
      <p className="text-[11px] font-medium leading-snug text-white sm:text-xs" data-id="element-186" data-mp="1ir7ukifwfhu4">
        <span className="sm:hidden" data-id="element-187" data-mp="1ip55q1qhfuqz">Ressources en français · Accès numérique immédiat</span>
        <span className="hidden sm:inline" data-id="element-188" data-mp="1dsy2igph0xcq">
          Ressources entièrement en français · Pensées pour les professeurs de physique-chimie ·
          Accès numérique immédiat
        </span>
      </p>
    </div>;
}